export const SEARCH_PLACEHOLDER_TEXT = "Ask a question..." as const;
// The API intentionally returns empty placeholder values when a tenant has no
// override. These preserve each component's established bundle fallback.
export const LANDING_SEARCH_PLACEHOLDER = "AI assist can answer your questions" as const;
export const FLOATING_SEARCH_PLACEHOLDER = "Not sure where to start? Search here." as const;
export const DRAWER_PLACEHOLDER = "Ask anything..." as const;
export const MAX_MESSAGE_LENGTH = 150;
